module.exports = __webpack_public_path__ + "img/flot-fyr-paa-snap-5.84dea033.png";